import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { ICommonServiceProps } from "@api/types/globalService.types";

type TCaptchaServiceProps = Omit<
  ICommonServiceProps,
  "filters" | "page" | "per_page"
>;

export const useCaptchaService = ({
  enableQuery = true,
  cacheKeys = [],
}: TCaptchaServiceProps) => {
  const captchaService = useQuery({
    queryKey: [...CACHE_KEYS.CAPTCHA, ...cacheKeys],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CAPTCHA,
      }),
    enabled: enableQuery,
  });
  return {
    services: { captchaService },
  };
};
